import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './style.css';



const options = {
    backgroundColor: 'rgb(249, 249, 249)',
    textColor: 'rgb(129, 129, 129)',
    highlightColor: 'rgb(23, 105, 255)'
};



class TabSelector extends Component {

    constructor(props) {
        super(props);

        this.options = Object.assign({}, options, props.options);
    }


    // Lifecycle Methods

    render() {
        return (
        <div className="hsg-ts-root"
            style={{backgroundColor: this.options.backgroundColor}}>

            {/* <div className="hsg-ts-wrapper">
                {this.renderTabs()}
            </div> */}

        </div>
        
        );
    }


    componentDidMount() {
        this.options = Object.assign({}, options, this.props.options);
    }


    componentWillReceiveProps(newProps) {
        this.options = Object.assign({}, options, newProps.options);
    }


    // Rendering Methods

    // renderTabs() {
    //     return this.props.tabList.map((item, pos) => {
    //         return <Tab
    //             key={pos}
    //             name={item}
    //             isSelected={pos === this.props.selected}
    //             onClick={() => {this.props.onTabSelected(pos)}}
    //             options={this.options} />
    //     });
    // }

}


TabSelector.propTypes = {
    tabList: PropTypes.arrayOf(PropTypes.string),
    selected: PropTypes.number.isRequired,
    onTabSelected: PropTypes.func.isRequired
};



// Local Components

class Tab extends Component {

    constructor(props) {
        super(props);

        this.options = Object.assign({}, options, props.options);
    }


    // Lifecycle Methods

    render() {
        return (
        <div className={"hsg-ts-tab-root" + (this.props.isSelected ? ' hsg-ts-tab-selected' : '')}
            style={{
                backgroundColor: this.options.backgroundColor,
                color: this.props.isSelected ? this.options.highlightColor : this.options.textColor,
                borderColor: this.options.highlightColor
            }}
            onClick={this.props.onClick}>

            <p className="hsg-ts-tab-text">{this.props.name}</p>

        </div>);
    }


    componentDidMount() {
        this.options = Object.assign({}, options, this.props.options);
    }


    componentWillReceiveProps(newProps) {
        this.options = Object.assign({}, options, newProps.options);
    }

}


Tab.propTypes = {
    name: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    options: PropTypes.object
};



export default TabSelector